"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeSquareBracketAfterBegin = void 0;
function escapeSquareBracketAfterBegin(tex) {
    return tex.replace(/(\\begin{[^}]*}\s*)\[/g, "$1{}[");
}
exports.escapeSquareBracketAfterBegin = escapeSquareBracketAfterBegin;
